export function getWalletPaymentAvailability({
  isGuest,
  isHidden,
  isEnabled,
  bookingPrice,
  walletBalance,
}: {
  isGuest: boolean;
  isHidden: boolean;
  isEnabled: boolean;
  bookingPrice: number | null;
  walletBalance: number;
}) {
  // A wallet with nothing in it is not a tender: a zero or negative balance
  // (the customer owes money) hides the option entirely rather than showing
  // a disabled "0.00" row. A positive-but-short balance stays visible and
  // disabled so the customer can see how far off they are.
  const visible =
    !isGuest &&
    !isHidden &&
    isEnabled &&
    bookingPrice !== null &&
    bookingPrice > 0 &&
    walletBalance > 0;

  return {
    visible,
    canPay:
      visible &&
      bookingPrice !== null &&
      Number.isFinite(walletBalance) &&
      walletBalance + 0.00001 >= bookingPrice,
  };
}

/**
 * Wallet settlement is independent from the tenant's card-payment switch.
 * Only the class template's direct-payment policy can hide it at selection time.
 */
export function shouldHideClassWalletPayment({
  isClassBooking,
  templateAllowsDirectPayment,
}: {
  isClassBooking: boolean;
  templateAllowsDirectPayment: boolean | null | undefined;
}) {
  return isClassBooking && templateAllowsDirectPayment === false;
}

/** Must stay aligned with settle_wallet_class_participant in 59-wallet.sql. */
export function isClassWalletSettleableStatus(paymentStatus: string) {
  return ['pending', 'unpaid', 'cash_unpaid'].includes(paymentStatus);
}
